import { Banner } from 'utils/banner/utils';
import { Campaign } from 'utils/campaign';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

const SET_BANNERS_PAGE_CAMPAIGN = 'SET_BANNERS_PAGE_CAMPAIGN';
const SET_BANNERS_PAGE_BANNERS = 'SET_BANNERS_PAGE_BANNERS';

interface PayloadTypes {
    [SET_BANNERS_PAGE_CAMPAIGN]: Campaign;
    [SET_BANNERS_PAGE_BANNERS]: Banner[];
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setBannersCampaign = ActionCreator(SET_BANNERS_PAGE_CAMPAIGN);
export const setBanners = ActionCreator(SET_BANNERS_PAGE_BANNERS);

interface BannersState {
    campaign: Campaign | null;
    banners: Banner[];
}

export const BANNERS_INITIAL_STATE: BannersState = {
    campaign: null,
    banners: [],
};

export default createReducer<BannersState, PayloadTypes>(BANNERS_INITIAL_STATE, {
    [SET_BANNERS_PAGE_CAMPAIGN]: (state, { payload }) => ({
        ...state,
        campaign: payload,
    }),
    [SET_BANNERS_PAGE_BANNERS]: (state, { payload }) => ({
        ...state,
        banners: payload,
    }),
});
